import React, { useState } from "react";
import "./Faq.css";
import { Helmet } from "react-helmet-async";

const Faq = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const faqs = [
    {
      question:
        "Why should I choose Just SEO over other SEO agencies in India?",
      answer:
        "Just SEO specializes in customized SEO strategies tailored for the Indian market. Our team has a proven track record of improving rankings for businesses across various industries in India, with transparent reporting and ethical white-hat techniques.",
    },
    {
      question: "What makes Just SEO's approach to SEO different?",
      answer:
        "We combine global SEO best practices with deep local market knowledge. Our data-driven approach focuses on your specific business goals rather than just keyword rankings, ensuring tangible ROI from your SEO investment.",
    },
    {
      question: "Do you have experience with businesses in my industry?",
      answer:
        "Our team has worked with diverse industries including e-commerce, healthcare, education, real estate, and B2B services across India. We customize strategies based on your industry's unique challenges and opportunities.",
    },
    {
      question: "How do you ensure results for Indian search engines?",
      answer:
        "We optimize for both Google India and regional search patterns. Our strategies account for local languages, mobile-first users, and India-specific search behaviors to maximize visibility.",
    },
    {
      question: "What reporting can I expect from Just SEO?",
      answer:
        "You'll receive monthly reports with key metrics like organic traffic, rankings, conversions, and ROI. Plus, we provide regular consultations to explain results and strategy adjustments.",
    },
    {
      question: "How quickly can I expect to see results?",
      answer:
        "Initial improvements often appear within 2-3 months, but sustainable SEO typically shows significant impact after 6-12 months of consistent implementation. We focus on long-term growth rather than quick fixes.",
    },
    {
      question: "Do you offer local SEO services for Indian businesses?",
      answer:
        "Yes, we specialize in local SEO for Indian cities and regions, including Google My Business optimization, local citations, and geo-targeted content strategies.",
    },
    {
      question: "What if I'm not satisfied with the services?",
      answer:
        "We offer a satisfaction guarantee with clear performance benchmarks. If we don't meet agreed-upon targets, we'll work extra to make it right or offer a partial refund based on our agreement.",
    },
    {
      question: "What SEO techniques do you use?",
      answer:
        "We strictly follow white-hat SEO techniques including technical SEO optimization, quality content creation, authoritative link building, on-page optimization, and user experience improvements - all compliant with Google's Webmaster Guidelines.",
    },
    {
      question: "Do you work with startups and small businesses?",
      answer:
        "Absolutely! We have affordable SEO packages specifically designed for Indian startups and small businesses. We help establish your online presence and compete effectively against larger competitors.",
    },
    {
      question: "How do you handle multilingual SEO for India?",
      answer:
        "We have specialists for Hindi, Tamil, Telugu, Bengali, Marathi and other regional languages. Our multilingual SEO includes proper hreflang implementation, culturally relevant content, and local keyword research.",
    },
    {
      question: "What's included in your basic SEO package?",
      answer:
        "Our basic package includes website audit, 15-20 keyword optimization, on-page SEO, technical fixes, monthly reporting, and 2 content pieces. We customize packages based on business needs and budgets.",
    },
    {
      question: "Do you provide SEO for e-commerce websites?",
      answer:
        "Yes, we specialize in e-commerce SEO with product page optimization, category structure, schema markup, image optimization, and strategies to reduce cart abandonment through organic search.",
    },
    {
      question: "How do you stay updated with SEO trends?",
      answer:
        "Our team regularly attends international SEO conferences, participates in Google Webmaster forums, conducts internal training sessions, and tests all algorithm updates to ensure our strategies remain effective.",
    },
    {
      question: "Can you help recover from Google penalties?",
      answer:
        "Yes, we have successfully helped many Indian businesses recover from manual and algorithmic penalties through thorough audits, corrective actions, and reconsideration requests.",
    },
    {
      question: "Do you offer content marketing services?",
      answer:
        "Content is core to our SEO strategy. We provide content planning, creation, optimization and promotion services with native English and regional language writers familiar with Indian markets.",
    },
    {
      question: "What's your pricing structure?",
      answer:
        "We offer transparent monthly retainers starting at ₹15,000/month for small businesses. Enterprise solutions are custom-priced based on scope, competition and business goals.",
    },
    {
      question: "How do you measure SEO success?",
      answer:
        "Beyond rankings, we track meaningful metrics like organic traffic growth, conversion rates, lead quality, revenue attribution, and improvement in domain authority over time.",
    },
    {
      question: "Do you offer international SEO services?",
      answer:
        "Yes, we help Indian businesses target global audiences with country-specific SEO, international link building, and geo-targeting strategies while maintaining your .in domain strength.",
    },
    {
      question: "What's your client onboarding process?",
      answer:
        "Our 4-step process includes: 1) Detailed website and competitor analysis 2) Strategy workshop 3) Implementation plan 4) Regular progress reviews with actionable insights.",
    },
  ];

  return (
    <div className="faq-container">
      <Helmet>
        <title>
          SEO & Digital Marketing FAQs – Your Questions Answered | Just SEO
        </title>
        <meta
          name="description"
          content="Have questions about SEO, Google rankings, or digital marketing? Explore our FAQ section for clear, expert answers from India’s leading SEO agency."
        />
        <meta
          name="keywords"
          content="AI SEO, artificial intelligence SEO, machine learning SEO, ChatGPT for SEO, AI content optimization, Google Bard SEO, NLP for SEO, AI keyword research, automated SEO, predictive SEO, AI backlink analysis, SEO automation tools, AI-powered rankings, generative AI SEO, AI meta descriptions, SEO machine learning,AI SEO tools, ChatGPT SEO prompts, Google Gemini SEO, multilingual AI SEO, AI content detection, AI for technical SEO, AI-powered backlinks, AI SERP analysis, AI for featured snippets, AI SEO audits, AI for local SEO, AI eCommerce SEO, AI video SEO, AI for voice search, AI content scoring, SEO machine learning models, neural matching optimization, AI for zero-click SEO, SEO services, digital marketing agency, search engine optimization, on-page SEO, off-page SEO, local SEO, eCommerce SEO, Google ranking, SEO expert, PPC advertising, social media marketing, content marketing, email marketing, YouTube SEO, voice search SEO, AI SEO, backlink building, keyword research, technical SEO, mobile SEO, Shopify SEO, WordPress SEO, SEO audit, Google Ads, Facebook Ads, LinkedIn marketing, SEO consultant, affordable SEO services, SEO for small business,content marketing, email marketing, influencer marketing, affiliate marketing, Google Ads, Facebook Ads, best SEO strategies 2024, how to improve Google ranking, SEO for small businesses, e-commerce SEO tips, voice search optimization, AI in digital marketing, Meta ads management, YouTube SEO techniques, mobile SEO best practices, SEO vs SEM,Search engine optimization,SEO services,SEO agency,SEO consultant,SEO expert,SEO company,SEO audit,SEO tools,Google ranking,Organic search traffic,Backlink building,Broken link building,Digital PR for SEO,Page speed optimization,SEO near me,Voice search optimization,Mobile-first indexing,Global SEO strategy,Multiregional SEO,How to improve SEO ranking, Real estate lead generation, Healthcare marketing,How to get backlinks naturally,Google Search Console,Google Analytics 4 (GA4),Rank tracking,Click-through rate (CTR),Bounce rate SEO,Dwell time,Organic impressions,Search query reports,Cannibalization tracking,SEO KPI dashboard,AI tools for digital marketing,AI tools for digital marketing"
        />
        <meta property="og:title" content="SEO & Digital Marketing FAQs – Your Questions Answered | Just SEO" />
        <meta
          property="og:image"
          content="https://justseo.in/faviconcopy.png"
        />
         <meta property="og:title" content="SEO & Digital Marketing FAQs – Your Questions Answered | Just SEO" />
        <meta property="og:url" content="https://justseo.in/faq" />
        <meta name="robots" content="index, follow" />
  
      </Helmet>
      <h1>Why Choose Just SEO for SEO Services India</h1>
      <div className="faq-list">
        {faqs.map((faq, index) => (
          <div
            key={index}
            className={`faq-item ${activeIndex === index ? "active" : ""}`}
            onClick={() => toggleFAQ(index)}
          >
            <div className="faq-question">
              <h3>{faq.question}</h3>
              <span className="toggle-icon">
                {activeIndex === index ? "-" : "+"}
              </span>
            </div>
            {activeIndex === index && (
              <div className="faq-answer">
                <p>{faq.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Faq;
